import React, { useEffect, useState } from "react";
import Pagination from "../../../utils/Paginate";
import TableLoader from "../../../Skeleton/TableLoader";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
// import { useAuth } from "../Auth/Auth";
import { apiHeader } from "../../../utils/apiHeader";
import axios from "axios";
import { globalConfig } from "../../../config/config";
// const querystring = require("querystring");

const ListContentFacades = () => {
  const [currentPage, setCurrentPage] = useState(1);
//   const { token, userMetadata } = useAuth();
	const token = globalConfig.hardcoded_header;
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [state, setState] = useState({
    contentFacades: [],
    filteredContentFacades: [],
  });

  useEffect(() => {
    handleOnLoad();
  }, []);

  useEffect(() => {
    handleSearch(search);
  }, [search]);
  useEffect(() => {
    console.log(state);
  }, [state]);
  const handleOnLoad = () => {
    setLoading(true);
    axios
      .get(`${globalConfig.apiDatahubUrl}/content-facades `, apiHeader(token))
      .then((res) => {
        const contentFacades = res.data;
        console.log(contentFacades);
        setState({
          ...state,
          contentFacades: contentFacades,
          filteredContentFacades: contentFacades,
        });
        setLoading(false);
        console.log(res.data[0]);
      })
      .catch((x) => {
      });
  };
  function onDelete(event) {
    let deleteID = event.target.id;
    axios
      .delete(
        `${globalConfig.apiDatahubUrl}/content-facades/` + deleteID,
        apiHeader(token)
      )
      .then((res) => {
        console.log("Delete Response:" + res.data);
        setState({ ...state, contentFacades: [], filteredContentFacades: [] });
        handleOnLoad();
      })
      .catch((err) => console.log("Err delete:" + err));

    setState({ ...state, contentFacades: [], filteredContentFacades: [] });
    handleOnLoad();
    // this.props.history.push("/list-content-facades");
  }

  const handleSearch = (search) => {
    let URL = `${globalConfig.apiDatahubUrl}/content-facades?filter[limit]=50`;
    URL += `&filter[where][or][0][contentFacadeName][regexp]=/(${search})/i&filter[where][or][1][contentFacadeDescription][regexp]=/(${search})/i`;
    axios.get(URL, apiHeader(token)).then((res) => {
      const contentFacades = res.data;
      console.log(contentFacades);
      setState({ ...state, filteredContentFacades: contentFacades });
      console.log(res.data[0]);
    })
    .catch((x) => {
    });
  };
  const indexOfLastData = currentPage * globalConfig.dataPerPage;
  const indexOfFirstData = indexOfLastData - globalConfig.dataPerPage;
  const currentData = state.filteredContentFacades.slice(
    indexOfFirstData,
    indexOfLastData
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  //handler for page
  const handlePage = (page) => {
    setCurrentPage(page);
  };
  return (
    <form>
    	<div style={{ display: "flex", justifyContent: "space-between" }}>
    		<h4>Content Facades</h4>
		<div style={{display:"flex",justifyContent:"flex-end"}}>
        	<Link to="/breeze/create-content-facade">
          <Button
            variant="contained"
            color="success"
          >
            Create
          </Button>
        </Link>&nbsp;
        <Link to="/breeze/list-content-facade-types">
          <Button
            variant="contained"
            color="warning"
          >
            Types
          </Button>
        </Link>&nbsp;
		<Link to="/breeze">
			<Button variant="contained">Go Back</Button>
		</Link>
		</div>
		</div>
		<hr/>

        <div className="form-group">
          <input
            className="form-control"
            type="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            id="exampleFormControlInput1"
            placeholder="Search"
          />
        </div>
        
        <div className="form-group row">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Name</th>
                <th scope="col">Description</th>
                <th scope="col">Type</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {!loading ? (
                currentData.map(
                  ({
                    contentFacadeId,
                    contentFacadeName,
                    contentFacadeDescription,
                    contentFacadeTypeId,
                  }) => {
                    return (
                      <tr>
                        <td>
                          <Link
                            to={{
                              pathname: "/manage-content-facades",
                              search: `?id=${contentFacadeId}`,
                            }}
                          >
                            {contentFacadeId}{" "}
                          </Link>
                        </td>
                        <td>
                          <Link
                            to={{
                              pathname: "/manage-content-facades",
                              search: `?id=${contentFacadeId}`,
                            }}
                          >
                            {contentFacadeName}{" "}
                          </Link>{" "}
                        </td>
                        <td>
                          <Link
                            to={{
                              pathname: "/manage-content-facades",
                              search: `?id=${contentFacadeId}`,
                            }}
                          >
                            {" "}
                            {contentFacadeDescription}{" "}
                          </Link>
                        </td>
                        <td>
                          <Link
                            to={{
                              pathname: "/manage-content-facades",
                              search: `?id=${contentFacadeId}`,
                            }}
                          >
                            {" "}
                            {contentFacadeTypeId}{" "}
                          </Link>
                        </td>
                        <td>
                          <Link
                            className="btn btn-success"
                            to={{
                              pathname: "/manage-content-facades",
                              search: `?id=${contentFacadeId}`,
                            }}
                          >
                            Edit{" "}
                          </Link>
                          &nbsp;
                          <button
                            onClick={onDelete}
                            id={contentFacadeId}
                            className="btn btn-danger"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    );
                  }
                )
              ) : (
                <tr>
                  {new Array(5).fill(0).map((_, index) => (
                    <TableLoader key={index} theme={"dark"} />
                  ))}
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination
          dataPerPage={globalConfig.dataPerPage}
          totaldata={state.filteredContentFacades.length}
          paginate={paginate}
          currentPage={currentPage}
          onChange={handlePage}
        />

    </form>
  );
};

export default ListContentFacades;
